import React, { useState } from "react";
import { PageTitle } from "@/components/SettingsPanel";
import { VenueCategoriesManager } from "@/components/VenueCategoriesManager";
import { EventTypesManager } from "@/components/EventTypesManager";
import { usePrefs } from "@/contexts/PrefsContext";
import { useAuth } from "@/contexts/AuthContext";

const TABS = ["spots", "events"] as const;

export default function AdminCategories() {
  const { t } = usePrefs();
  const { user } = useAuth();
  const canEdit = !!user && (user.admin_role || "super") === "super";
  const [tab, setTab] = useState<(typeof TABS)[number]>("spots");
  return (
    <div data-testid="admin-categories-page" className="space-y-5">
      <PageTitle title={t("cat.title")} sub={t("cat.sub")} />
      <div className="flex gap-2 overflow-x-auto no-scrollbar">
        {TABS.map((k) => (
          <button key={k} data-testid={`categories-tab-${k}`} aria-pressed={tab === k} onClick={() => setTab(k)}
            className={`h-10 px-5 shrink-0 rounded-full text-sm font-bold ${tab === k ? "bg-primary text-primary-foreground" : "bg-card border"}`}>{t(`cat.tab.${k}`)}</button>
        ))}
      </div>
      {tab === "events" && <EventTypesManager canEdit={canEdit} />}
      {tab === "spots" && <VenueCategoriesManager canEdit={canEdit} kind="spot" />}
    </div>
  );
}
